import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ClickableElement from "../../components/utils/ClickableElement";

export const TabsContainer = styled.div`
  width: ${({ theme }) => theme.primaryTheme.maxWidth};
`;

export const TabLink = styled(Link)`
  text-decoration: none;
  margin: 0.2rem;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  width: 100%;
  @media (${({ theme }) => theme.breakpoints.min800}) {
    flex: 1;
  }
`;

export const TabButton = styled(ClickableElement as any)<{ selected: boolean }>(
  ({ theme, selected }) => `
  background: ${selected ? theme.colors.highlightLightGrey : theme.colors.lightgrey3};
  display: block;
  font-size: ${theme.primaryTheme.primaryFontSize};
  font-family: ${theme.fonts.OpenSans};
  height: 5rem;
  width: 100%;
  text-transform: uppercase;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
`
);

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  @media (${({ theme }) => theme.breakpoints.min800}) {
    flex-direction: row;
  }
`;

export interface ITabInformation<EnumOption> {
  tabItem: EnumOption;
  queryParam: string;
  title: string;
}

export interface ITabButtonsProps<EnumOption> {
  tabs: Array<ITabInformation<EnumOption>>;
  displayed: EnumOption;
  setSelected: (tab: EnumOption) => () => void;
  queryParamName?: string;
}

export const TabButtons = <T extends string>({
  tabs,
  displayed,
  setSelected,
  queryParamName = "tab",
}: ITabButtonsProps<T>) => (
  <ButtonRow>
    {tabs.map((tab, idx) => (
      <TabLink to={`?${queryParamName}=${tab.queryParam}`} key={idx}>
        <TabButton selected={displayed === tab.tabItem} onClick={setSelected(tab.tabItem)}>
          {tab.title}
        </TabButton>
      </TabLink>
    ))}
  </ButtonRow>
);
